export default __webpack_public_path__ + "img/365d9d0a64e42aeb7b414b7d368b3421.png";